import React, {useState} from 'react';
import styles from './pilltag_group.module.css';

export const PillTagGroup = ({children, maxVisible}: Props) => {
  const [viewAll, setViewAll] = useState(false);
  const count = React.Children.count(children);
  const visible = maxVisible || count;
  const extra = Math.max(0, count - visible);
  return (
    <div className={styles.pilltagGroup}>
      {viewAll ? children : React.Children.toArray(children).slice(0, visible)}
      {extra > 0 && (
        <button className={styles.viewAll} onClick={() => setViewAll(viewAll ? false : true)}>
          {viewAll ? 'show less' : `+${extra} more`}
        </button>
      )}
    </div>
  );
};

type Props = {
  children?: React.ReactNode;
  maxVisible?: number;
};
